import { render, staticRenderFns } from "./JobsClosingReasonsCountCard.vue?vue&type=template&id=f632e2ae&"
import script from "./JobsClosingReasonsCountCard.vue?vue&type=script&lang=js&"
export * from "./JobsClosingReasonsCountCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports